<script>
import { mapGetters } from 'vuex'

import Translatable from '@src/mixins/translatable.js'

import PassTypeCard from '@components/e-shop/pass-type-card.vue'
import PassTypeForm from '@components/e-shop/pass-type-form.vue'

export default {
  components: {
    PassTypeCard,
    PassTypeForm
  },
  mixins: [
    Translatable
  ],
  computed: {
    ...mapGetters('eShop', [
      'passTypeCards',
      'subscribe'
    ]),
  },
  methods: {
    changeSubscribe() {
      this.$store.commit('eShop/changeSubscribe')
    }
  },
}
</script>

<template>
  <div class="content">
    <div class="type-container">
      <div class="type-card-container">
        <PassTypeCard v-for="(card, index) in passTypeCards" :key="index" :card="card"/>
      </div>
      <div class="warning-container">
        <div class="warning-icon"></div>
        <p v-html="getTranslatedContent('ESHOP_select_the_type_warning')"></p>
      </div>
    </div>
    <div class="user-form-container">
      <PassTypeForm />
      <div class="check-container">
        <div class="check-icon" :class="subscribe && 'checked'" @click="changeSubscribe"></div>
        <p v-html="getTranslatedContent('ESHOP_select_the_type_subscription')"></p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
@import '@styles/form.scss';

.content {
  display: grid;
  column-gap: 48px;
  margin-top: 30px;
  grid-template-columns: repeat(2, 1fr);
}

.type-container {
  display: flex;
  flex-direction: column;
}

.type-card-container {
  display: grid;
  column-gap: 20px;
  grid-template-columns: repeat(2, 1fr);
}

.warning-container, .check-container {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  color: $green;

  display: flex;
  align-items: center;
  margin-top: 32px;
}

.check-container {
  font-family: Open Sans Semibold;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  text-transform: none;
  color: $gray;

  margin-top: 19px;
}

.icon-mixin {
  min-width: 24px;
  width: 24px;
  height: 24px;
}

.warning-icon {
  @extend .icon-mixin;
  background: url("../../assets/icons/e-warning.svg") center no-repeat;
  margin-right: 10px
}

.check-icon {
  @extend .icon-mixin;
  cursor: pointer;
  background: url("../../assets/icons/e-non-checked.svg") center no-repeat;
  margin-right: 21px;

  &.checked {
    background: url("../../assets/icons/e-checked.svg") center no-repeat;
  }
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {

  .content {
    width: 100%;
    grid-template-columns: repeat(1, 1fr);
    margin-top: 0;
  }

  .type-card-container {
    column-gap: 12px;
  }

  .check-container {
    margin-top: 19px;
  }

  .user-form {
    margin: 43px 0 0 0;
  }
}
</style>
